// extracted by mini-css-extract-plugin
export var disabled = "_2x-3";
export var growableInput = "_2x-0";
export var tagContainer = "_2x-2";
export var textInput = "_2x-1";